

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import store from './store'
import router from './router'
import Storage from 'vue-ls'
import '@/styles/index.scss' 
import '@/assets/iconfont/iconfont.css'
import '@/assets/fontTwo/iconfont.css'

import './permission' 
import * as filters from './filters' 
import constGlobal from './utils/constGlobal'
import defaultTip from './components/defaultTip'
import defaultEarch from './components/defaultEarth'
import global from './utils/global'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import { InfiniteScroll } from 'mint-ui'
import wxShare from '@/utils/wx/wxShare.js'

FastClick.attach(document.body)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(DatetimePlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(InfiniteScroll)
Vue.use(defaultTip)
Vue.use(defaultEarch)
Vue.use(wxShare)

const storageOptions = {
namespace: 'we', // key prefix
name: 'ls', // name variable Vue.[ls] or this.[$ls],
storage: 'local' 
}
Vue.use(Storage, storageOptions)
Vue.prototype.$bus = new Vue()
Vue.prototype.$constGlobal = constGlobal
Vue.prototype.$common = global


Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const bus = new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')

window.bus = bus



// WEBPACK FOOTER //
// ./src/main.js